import { Input } from 'antd'
import { Col, Container, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import GuideButtons from '../../components/GuideButtons'
import { useWizardForm } from '../../hooks'

function ProjectInfo({ onNext, onPrevious, formData = {}, setFormData }) {
  const { t } = useTranslation()

  const [, , updateForm] = useWizardForm(setFormData)
  const handleChange = (e) => updateForm(e, formData)

  const { title } = formData

  return (
    <div className="card-body-container card-body-info-container">
      <div className="card card-body">
        <div className="progressbar-container">
          <div className="text-center mt-3">
            <h4>{t('book_setup_guide_second_title')}</h4>
          </div>

          <div className="text-left mt-5 mb-5">
            <Container>
              <Row className="mb-3">
                <Col md={{ span: 2 }}>
                  <label>{t('book_title')}</label>
                </Col>
                <Col md={{ span: 10 }}>
                  <Input
                    name="title"
                    size="large"
                    onChange={handleChange}
                    maxLength="25"
                    defaultValue={title}
                    placeholder={t('book_title_input_placeholder')}
                  />
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      </div>

      <GuideButtons onNext={onNext} onPrevious={onPrevious} disabled={!title} />
    </div>
  )
}

export default ProjectInfo
